export default function SectionEyebrow({ children, className = "", color = "gold" }) {
  const colorClass =
    color === "gold" ? "text-[#C9A84C]" : color === "white" ? "text-white/70" : "text-[#4A90D9]";
  return (
    <div
      className={`inline-flex items-center gap-3 text-xs uppercase tracking-[0.2em] font-medium ${colorClass} ${className}`}
    >
      <span className={`h-[1px] w-8 ${color === "gold" ? "bg-[#C9A84C]" : color === "white" ? "bg-white/40" : "bg-[#4A90D9]"}`} />
      {children}
    </div>
  );
}
